document.addEventListener('DOMContentLoaded', () => {
	const loading = document.querySelector('.contact-form .loading')
	const submitBtn = document.querySelector('.contact-form button[type=submit]')
	if(submitBtn){
		submitBtn.addEventListener('click', () => {
			if (!submitBtn.classList.contains('disabled')) {
				loading.classList.remove('close')
			}
		})
		}
})



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/contact-form-loading/script.js